
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export interface ConfirmationModalData {
  title: string;
  message: string;
  itemName: string;
  confirmButtonText: string;
  confirmButtonClass: string;
  iconClass: string;
  details?: string; // Optional additional details/information
  errorMessage?: string;
  hideMessage?: boolean;
  hideDefaultNote?: boolean;
  hideCancelButton?: boolean;
}

@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  imports: [],
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmationModalComponent {
  @Input() isVisible = false;
  @Input() modalData: ConfirmationModalData | null = null;
  @Input() isLoading = false;
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  onConfirm() {
    this.confirm.emit();
  }

  onCancel() {
    this.cancel.emit();
  }

  onBackdropClick(event: Event) {
    if (event.target === event.currentTarget) {
      this.cancel.emit();
    }
  }
}
